const AsnStatus = {
    // RASCUNHO - 1
    FLAG_STATUS_DRAFT: "RAS",
            
    // CANCELADO - 12
    FLAG_STATUS_CANCELLED: "CAN",

    // PENDENTE DE ENTRADA DE MVM - 2
    FLAG_STATUS_PENDING_EMITTED: "EMT",
   
    // CONCLUÍDO - 11
    FLAG_STATUS_FINISHED: "CON",

}

export default AsnStatus;